import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, Observable } from 'rxjs';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';
import { ToastService } from './toast.service';

@Injectable()
export class DepartmentCheckInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private translateService: TranslateService,
    private store: Store
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenantId = this.store.selectSnapshot(TenantUserAccessState.currentTenantId);
    const departmentId = this.store.selectSnapshot(TenantUserAccessState.currentDepartmentId);
    const noDepartments = !!tenantId && request.url?.includes(`${tenantId}//`) && !departmentId;
    if (!noDepartments) {
      return next.handle(request);
    }

    this.translateService.get('userHasNoActiveDepartments').subscribe((value) => {
      this.toastService.error(value);
    });
    return EMPTY;
  }
}
